import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  id: "simpleSearchOverlay",
  class: "simple-search__overlay"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]

import { ref, onMounted, watch, Ref } from "vue";
import {
  FormUnit,
  FormUnitRow,
  FormUnitCell,
  RadioItem,
  SelectItem,
  ButtonContainer,
  ButtonItem,
  PopupWindow,
} from "@/components/modules";
import { withDefaults } from "vue";
import {
  dayTypeList,
  simpleSearchDataTypeList,
} from "./simpleSearchDataTypeList";
import { format } from "date-fns";
import { windowDialogImportantIndex } from "@/components/modules/popup-window/WindowDialogState";

interface Props {
  isOpen: boolean;
  isFirstTime: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'simple-search',
  props: {
    isOpen: { type: Boolean },
    isFirstTime: { type: Boolean }
  },
  emits: ["submitSimpleSearch", "close"],
  setup(__props: any, { emit }) {

const props = __props;





/**
 * 地整リスト
 */
const groundLevelingList = [
  { name: "北海道開発局：札幌市", latitude: 43.071087, longitude: 141.351852 },
  { name: "東北地整：仙台市", latitude: 38.267569, longitude: 140.873464 },
  { name: "関東地整：さいたま市", latitude: 35.89077, longitude: 139.634003 },
  { name: "北陸地整：新潟市", latitude: 37.895344, longitude: 139.0177 },
  { name: "中部地整：名古屋市", latitude: 35.179718, longitude: 136.903015 },
  { name: "近畿地整：大阪市", latitude: 34.683384, longitude: 135.519501 },
  { name: "中国地整：広島市", latitude: 34.398636, longitude: 132.462082 },
  { name: "四国地整：高松市", latitude: 34.352581, longitude: 134.045914 },
  { name: "九州地整：福岡市", latitude: 33.588326, longitude: 130.423904 },
  {
    name: "沖縄総合事務局：那覇市",
    latitude: 26.227432,
    longitude: 127.691818,
  },
];

/**
 * モード選択画面表示フラグ
 */
const isSelectMode = ref(true);

/**
 * データ種別
 */
const dataType = ref(simpleSearchDataTypeList.travosRealTime5Minute);

/**
 * 地整
 */
const groundLevelIndex = ref(0);

/**
 * 平休
 */
const dayType = ref(dayTypeList.weekday);

/**
 * 対象日
 */
const targetDay: Ref<Date> = ref();

/**
 * 対象日最小
 */
const rangeMinDate: Ref<Date> = ref();

/**
 * 対象日最大
 */
const rangeMaxDate: Ref<Date> = ref();

/**
 * 対象年月（MonthPicker用）
 */
const targetMonth = ref();

/**
 * 対象時刻
 */
const targetTime = ref(0);

/**
 * 速報値用時分
 */
const realTimeDate = ref(new Date());

/**
 * 速報用時分表示
 */
const formattedRealTimeDate = ref("");

/**
 * 現在時間更新インターバル
 */
let updateRealTimeInterval: any;

/**
 * 表示位置
 */
const positionStyle = ref({ top: "330px", left: "750px" });

/**
 * 簡易選択モード開始
 */
const stastSimpleSelect = () => {
  isSelectMode.value = false;
};

/**
 * データ種別更新
 */
const updateDataType = async (selectDataType: simpleSearchDataTypeList) => {
  clearInterval(updateRealTimeInterval);
  dataType.value = selectDataType;
  let jsonUrl: string[] = [];
  switch (selectDataType) {
    case simpleSearchDataTypeList.travosRealTime5Minute:
    case simpleSearchDataTypeList.travosRealTime1Hour:
      updateRealTimeInterval = setInterval(updateRealTime, 60 * 1000);
      updateRealTime();
      break;
    case simpleSearchDataTypeList.etcDrmDay:
      jsonUrl.push(process.env.VUE_APP_DATE_RANGE_ETC_DRM_LNK_1H_URL);
      break;
    case simpleSearchDataTypeList.etcDrmMonth:
      jsonUrl.push(process.env.VUE_APP_DATE_RANGE_ETC_DRM_LNK_1MONTH_URL);
      break;
  }
  if (jsonUrl.length === 1) {
    const randStr = Math.random().toString(36).substring(2).slice(-7);
    await fetch(
      process.env.VUE_APP_DATE_RANGE_BASE_URL + jsonUrl + "?token=" + randStr
    )
      .then((res) => {
        if (res?.status === 404) {
          return null;
        }
        return res?.json();
      })
      .then((res: any) => {
        if (dataType.value === simpleSearchDataTypeList.etcDrmMonth) {
          const maxDate = new Date(res.maxdate);
          targetMonth.value = {
            month: maxDate.getMonth(),
            year: maxDate.getFullYear(),
          };
          rangeMinDate.value = new Date(res.mindate);
          rangeMaxDate.value = new Date(res.maxdate);
          rangeMaxDate.value.setMonth(rangeMaxDate.value.getMonth());
          if (
            rangeMaxDate.value.getDate() === 1 &&
            rangeMaxDate.value.getHours() < 7
          ) {
            rangeMaxDate.value.setMonth(rangeMaxDate.value.getMonth() - 1);
          }
        } else {
          targetDay.value = new Date(res.maxdate);
          if (targetDay.value.getHours() < 7) {
            targetDay.value.setDate(targetDay.value.getDate() - 1);
          }
          rangeMinDate.value = new Date(res.mindate);
          rangeMaxDate.value = targetDay.value;
        }
        targetTime.value = 7;
        return;
      });
  } else if (jsonUrl.length === 2) {
    let resArray: any[] = [];
    jsonUrl.forEach(async (url) => {
      const randStr = Math.random().toString(36).substring(2).slice(-7);
      await fetch(
        process.env.VUE_APP_DATE_RANGE_BASE_URL + url + "?token=" + randStr
      )
        .then((res) => {
          if (res?.status === 404) {
            return null;
          }
          return res?.json();
        })
        .then((res) => {
          resArray.push(res);
          let maxResult;
          if (resArray.length === 2) {
            if (
              new Date(resArray[0].maxdate) >= new Date(resArray[1].maxdate)
            ) {
              maxResult = resArray[0];
            } else {
              maxResult = resArray[1];
            }
            targetDay.value = new Date(maxResult.maxdate);
            if (targetDay.value.getHours() < 7) {
              targetDay.value.setDate(targetDay.value.getDate() - 1);
            }
            rangeMinDate.value = new Date(maxResult.mindate);
            rangeMaxDate.value = new Date(maxResult.maxdate);
            targetTime.value = 7;
          }
          return;
        });
    });
  }
};

/**
 * 地整更新
 */
const updateGroundLevelIndex = (selectIndex: number) => {
  groundLevelIndex.value = selectIndex;
};

/**
 * 対象時間更新
 */
const updateTargetTime = (selectTime: string) => {
  targetTime.value = Number(selectTime);
};

/**
 * 平休更新
 */
const updateDayType = (selectDayType: dayTypeList) => {
  dayType.value = selectDayType;
};

/**
 * 現在時間更新
 */
const updateRealTime = () => {
  realTimeDate.value = new Date();
  if (dataType.value === simpleSearchDataTypeList.travosRealTime5Minute) {
    realTimeDate.value.setMinutes(realTimeDate.value.getMinutes() - 25);
    realTimeDate.value.setMinutes(
      Math.floor(realTimeDate.value.getMinutes() / 5) * 5
    );
  } else {
    realTimeDate.value.setMinutes(realTimeDate.value.getMinutes() - 85);
    realTimeDate.value.setMinutes(0);
  }
  formattedRealTimeDate.value = format(realTimeDate.value, "yyyy/MM/dd HH:mm");
};

/**
 * 表示
 */
const indicateMap = () => {
  let targetDate = null;
  switch (dataType.value) {
    case simpleSearchDataTypeList.etcDrmDay:
      targetDate = new Date("0001/01/01");
      targetDate.setFullYear(targetDay.value.getFullYear());
      targetDate.setMonth(targetDay.value.getMonth());
      targetDate.setDate(targetDay.value.getDate());
      targetDate.setHours(targetTime.value);
      break;
    case simpleSearchDataTypeList.etcDrmMonth:
      targetDate = new Date("0001/01/01");
      targetDate.setFullYear(targetMonth.value.year);
      targetDate.setMonth(targetMonth.value.month);
      targetDate.setHours(targetTime.value);
      break;
  }
  emit(
    "submitSimpleSearch",
    dataType.value,
    groundLevelingList[groundLevelIndex.value].latitude,
    groundLevelingList[groundLevelIndex.value].longitude,
    targetDate,
    dayType.value
  );
};

/**
 * 画面を閉じる
 */
const close = () => {
  clearInterval(updateRealTimeInterval);
  emit("close");
};

watch(
  () => props.isOpen,
  () => {
    if (props.isOpen) {
      updateRealTimeInterval = setInterval(updateRealTime, 60 * 1000);
      updateRealTime();
      setTimeout(() => {
        document.getElementById("simpleSearchOverlay").style.zIndex = (
          windowDialogImportantIndex - 1
        ).toString();
      }, 10);
    }
  },
  { immediate: true }
);

/**
 * 初期処理
 */
onMounted(() => {
  positionStyle.value = {
    top: (window.innerHeight - 387) / 2 + "px",
    left: (window.innerWidth - 500) / 2 + "px",
  };
});

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
      [_vShow, props.isOpen]
    ]),
    (props.isOpen && isSelectMode.value && _ctx.isFirstTime)
      ? (_openBlock(), _createBlock(_unref(PopupWindow), {
          key: 0,
          "data-html2canvas-ignore": "",
          title: "モード選択",
          width: "500px",
          windowId: "simpleSearch",
          draggable: false,
          important: true,
          isDisplayBase: true,
          class: "simple-search__window",
          onCloseClick: close
        }, {
          "main-content": _withCtx(() => [
            _createVNode(_unref(FormUnit), {
              column: ['230px', '230px'],
              "gap-column": "10px"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormUnitRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ButtonContainer), { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ButtonItem), {
                              size: "ml",
                              onClick: stastSimpleSelect
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("簡易検索モード")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ButtonContainer), { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ButtonItem), {
                              size: "ml",
                              onClick: close
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("通常検索モード")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(FormUnit), {
              column: ['230px', '230px'],
              "gap-column": "10px"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormUnitRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormUnitCell), { align: "center" }, {
                      default: _withCtx(() => [
                        _createTextVNode("交通量、旅行速度のみを"),
                        _hoisted_2,
                        _createTextVNode("速やかに見たい場合はこちら")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormUnitCell), { align: "center" }, {
                      default: _withCtx(() => [
                        _createTextVNode("各種データを詳しく"),
                        _hoisted_3,
                        _createTextVNode("検索したい場合はこちら")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!isSelectMode.value || !_ctx.isFirstTime)
      ? _withDirectives((_openBlock(), _createBlock(_unref(PopupWindow), {
          key: 1,
          isOpen: props.isOpen && (!isSelectMode.value || !_ctx.isFirstTime),
          "data-html2canvas-ignore": "",
          title: isSelectMode.value && _ctx.isFirstTime ? 'モード選択' : '簡易検索モード',
          width: "500px",
          windowId: "simpleSearch",
          draggable: false,
          important: true,
          isDisplayBase: true,
          class: "simple-search__window",
          onCloseClick: close
        }, {
          "main-content": _withCtx(() => [
            _createVNode(_unref(FormUnit), null, {
              default: _withCtx(() => [
                _createVNode(_unref(FormUnitCell), null, {
                  default: _withCtx(() => [
                    _createTextVNode("- 表示データの選択")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormUnitCell), { "gap-row": "5px" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(RadioItem), {
                          label: "交通量（5分値・トラカン地点）＊速報値",
                          name: "dataType",
                          checked: 
                dataType.value == _unref(simpleSearchDataTypeList).travosRealTime5Minute
              ,
                          onUpdate: _cache[0] || (_cache[0] = ($event: any) => (
                updateDataType(_unref(simpleSearchDataTypeList).travosRealTime5Minute)
              ))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(RadioItem), {
                          label: "交通量（1時間値・トラカン地点）＊速報値",
                          name: "dataType",
                          checked: 
                dataType.value == _unref(simpleSearchDataTypeList).travosRealTime1Hour
              ,
                          onUpdate: _cache[1] || (_cache[1] = ($event: any) => (
                updateDataType(_unref(simpleSearchDataTypeList).travosRealTime1Hour)
              ))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(RadioItem), {
                          label: "旅行速度（日別・時間帯別・DRM区間）",
                          name: "dataType",
                          checked: dataType.value == _unref(simpleSearchDataTypeList).etcDrmDay,
                          onUpdate: _cache[2] || (_cache[2] = ($event: any) => (updateDataType(_unref(simpleSearchDataTypeList).etcDrmDay)))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(RadioItem), {
                          label: "旅行速度（月別・時間帯別・DRM区間）",
                          name: "dataType",
                          checked: dataType.value == _unref(simpleSearchDataTypeList).etcDrmMonth,
                          onUpdate: _cache[3] || (_cache[3] = ($event: any) => (updateDataType(_unref(simpleSearchDataTypeList).etcDrmMonth)))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(FormUnit), null, {
              default: _withCtx(() => [
                _createVNode(_unref(FormUnitCell), null, {
                  default: _withCtx(() => [
                    _createTextVNode("- 表示エリアの選択")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormUnitCell), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SelectItem), {
                      value: groundLevelIndex.value,
                      onUpdate: updateGroundLevelIndex,
                      class: "simple-search__ground-level"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(groundLevelingList, (ele, index) => {
                          return _createElementVNode("option", {
                            value: index,
                            key: ele.name
                          }, _toDisplayString(ele.name), 9, _hoisted_4)
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(FormUnit), {
              column: ['120px', '45px', 'auto'],
              "gap-column": "10px"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FormUnitCell), null, {
                  default: _withCtx(() => [
                    _createTextVNode("- 表示したい期間")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormUnitRow), null, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        (dataType.value == _unref(simpleSearchDataTypeList).etcDrmMonth)
                          ? (_openBlock(), _createBlock(_component_VueDatePicker, {
                              key: 0,
                              monthPicker: "",
                              class: "simple-search__date-picker",
                              locale: "jp",
                              "text-input": "",
                              "auto-apply": "",
                              "enable-time-picker": false,
                              format: 'yyyy/MM',
                              "min-date": rangeMinDate.value,
                              "max-date": rangeMaxDate.value,
                              "start-date": rangeMaxDate.value,
                              modelValue: targetMonth.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((targetMonth).value = $event))
                            }, null, 8, ["min-date", "max-date", "start-date", "modelValue"]))
                          : (_openBlock(), _createBlock(_component_VueDatePicker, {
                              key: 1,
                              class: "simple-search__date-picker",
                              locale: "jp",
                              "text-input": "",
                              "auto-apply": "",
                              "enable-time-picker": false,
                              format: 'yyyy/MM/dd',
                              "min-date": rangeMinDate.value,
                              "max-date": rangeMaxDate.value,
                              "start-date": rangeMaxDate.value,
                              modelValue: targetDay.value,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((targetDay).value = $event))
                            }, null, 8, ["min-date", "max-date", "start-date", "modelValue"]))
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, 
              dataType.value == _unref(simpleSearchDataTypeList).etcDrmMonth ||
              dataType.value == _unref(simpleSearchDataTypeList).etcDrmDay
            ]
                    ]),
                    _withDirectives(_createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SelectItem), {
                          value: targetTime.value.toString(),
                          onUpdate: updateTargetTime,
                          class: "simple-search__target-time"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (n) => {
                              return _createElementVNode("option", {
                                key: n - 1,
                                value: (n - 1).toString()
                              }, _toDisplayString(n - 1), 9, _hoisted_5)
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, 
              dataType.value == _unref(simpleSearchDataTypeList).etcDrmMonth ||
              dataType.value == _unref(simpleSearchDataTypeList).etcDrmDay
            ]
                    ]),
                    _withDirectives(_createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        _createTextVNode("時台")
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, 
              dataType.value == _unref(simpleSearchDataTypeList).etcDrmMonth ||
              dataType.value == _unref(simpleSearchDataTypeList).etcDrmDay
            ]
                    ])
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_unref(FormUnitCell), { class: "simple-search__realtime-string" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(formattedRealTimeDate.value), 1)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, 
            dataType.value == _unref(simpleSearchDataTypeList).travosRealTime5Minute ||
            dataType.value == _unref(simpleSearchDataTypeList).travosRealTime1Hour
          ]
                ]),
                _withDirectives(_createVNode(_unref(FormUnitCell), null, {
                  default: _withCtx(() => [
                    _createTextVNode("※最新時刻のデータを表示します。（日時の変更はできません）")
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, 
            dataType.value == _unref(simpleSearchDataTypeList).travosRealTime5Minute ||
            dataType.value == _unref(simpleSearchDataTypeList).travosRealTime1Hour
          ]
                ])
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_unref(FormUnit), null, {
              default: _withCtx(() => [
                _createVNode(_unref(FormUnitCell), null, {
                  default: _withCtx(() => [
                    _createTextVNode("- 平休")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormUnit), { "gap-row": "5px" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(RadioItem), {
                          label: "平日（月曜～金曜の祝日除く）",
                          name: "dayType",
                          checked: dayType.value == _unref(dayTypeList).weekday,
                          onUpdate: _cache[6] || (_cache[6] = ($event: any) => (updateDayType(_unref(dayTypeList).weekday)))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(RadioItem), {
                          label: "休日（土曜,日曜,祝日）",
                          name: "dayType",
                          checked: dayType.value == _unref(dayTypeList).holiday,
                          onUpdate: _cache[7] || (_cache[7] = ($event: any) => (updateDayType(_unref(dayTypeList).holiday)))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormUnitCell), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(RadioItem), {
                          label: "全日",
                          name: "dayType",
                          checked: dayType.value == _unref(dayTypeList).allDay,
                          onUpdate: _cache[8] || (_cache[8] = ($event: any) => (updateDayType(_unref(dayTypeList).allDay)))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, dataType.value == _unref(simpleSearchDataTypeList).etcDrmMonth]
            ]),
            _createVNode(_unref(ButtonContainer), { align: "right" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ButtonItem), {
                  onClick: indicateMap,
                  disabled: 
            ([_unref(simpleSearchDataTypeList).etcDrmDay].includes(dataType.value) &&
              !targetDay.value) ||
            (dataType.value === _unref(simpleSearchDataTypeList).etcDrmMonth && !targetMonth.value)
          
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("表示")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["isOpen", "title"])), [
          [_vShow, props.isOpen]
        ])
      : _createCommentVNode("", true)
  ], 64))
}
}

})